import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import * as styles from './state-select.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StateSelect = props => {
  var onChangeState = newState => {
    if (props.onStateSelect) {
      props.onStateSelect(newState.label);
    }
    window.location = props.browseUrlFormat.replace('%state', newState.value);
  };
  var states = [{
    value: 'nsw',
    label: 'NSW'
  }, {
    value: 'vic',
    label: 'VIC'
  }, {
    value: 'qld',
    label: 'QLD'
  }, {
    value: 'wa',
    label: 'WA'
  }, {
    value: 'sa',
    label: 'SA'
  }, {
    value: 'nt',
    label: 'NT'
  }, {
    value: 'tas',
    label: 'TAS'
  }];
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(Select, {
    placeholder: props.placeholder,
    className: "allhomes-search-frontpage__state-select-container-element",
    options: states,
    onChange: onChangeState,
    searchable: false,
    clearable: false
  }));
};
StateSelect.propTypes = {
  placeholder: PropTypes.string.isRequired,
  browseUrlFormat: PropTypes.string.isRequired,
  onStateSelect: PropTypes.func
};
StateSelect.defaultProps = {
  onStateSelect: () => {}
};
export default StateSelect;